<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">取样判定</h1>-->
    <!--</header>-->
    <div class="mui-content">
      <div class="title-name">
        <span class="">取样判定</span>
      </div>
       <div style="padding-top: 10px;">
        <div class="sampling-first-title">
           <h4 style="padding-left: 10px;font-size: 15px;font-weight: 500;"></h4>
        </div>
        <!--第一行-->
        <div class="form-group">
         <div class="input-label">
           <label >物料:</label>
         </div>
         <div class="form-input">
          <!--  <select v-model="selectedWph" @change="getContractList">
             <option v-for="item in clothList" :value="item">{{item.scxtwph+" "+item.scxtwpmc}}</option>
           </select> -->
           <div style="width: 85%;margin-bottom: 15px;">
              <multiselect v-model="selectedWph" :options="clothList" :close-on-select="true" placeholder="请输入物料"  label="dipname" track-by="scxtwph" @select="wphSelected" :multiple="false" :showLabels = "false" :allowEmpty="false"></multiselect>
          </div>
         </div>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label >外注订单:</label>
          </div>
          <div class="form-input">
            <select  v-model="selectedContractItem">
              <option v-for="item in contractList" :value="item">{{item.ddh}}</option>
            </select>
          </div>
        </div>
        <div class="form-group" style="width:100%;margin-top: 30px;">
          <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;min-width: 80px;" id="samplingupdate" @tap="sampleupdate" v-show="selectedContractItem.ddqf != '2'">取样</button>
          <button type="button" class="mui-btn mui-btn-default btn-92" style="margin: auto;min-width: 80px;" id="samplinghistorybtn" @tap="samplehis">取样履历</button>
        </div>


      </div>
    </div>
  </section>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import Vue from 'vue'
    // register globally
    Vue.component('multiselect', Multiselect)
    export default {
      name: "sampling",
      components: { Multiselect },
      data(){
        return{
          contractList:[],
          clothList:[],
          selectedContractItem:{},
          selectedContract:"",
          selectedWph:{},
          selected_ddqf:""
        }
      },
      methods:{
        // 物料获取
        clothQuery(){
          var v=this;
          v.nyy.doPost("/Sample/getMateriaList",{}, 
            function(result){
              if(result.status){
                 v.clothList=result.data.infoLst;
                 if(v.clothList.length>0){
                   v.selectedWph=v.clothList[0];
                   v.getContractList();
                 }else{
                  v.selectedWph = {};
                 }
              }
            }
          );
        },
        sampleupdate(){// 取样
          // 判断是否是编织 。ddqf = "2" ，则进入samplingWeavingUpdate 否则 samplingUpdate
          var v=this;
          if(!v.selectedWph.wph){
             mui.alert("请先选择物料，再操作","错误提示");
             return;
          }
          // 订单号
          v.selectedContract = v.selectedContractItem.ddh;
          if(!v.selectedContract){
            mui.alert("请先选择物料下的订单，再操作","错误提示");
             return;
          }
          // 订单区分
          v.selected_ddqf = v.selectedContractItem.ddqf;
          var para={ddh:v.selectedContract,wph:v.selectedWph.wph,scxtwph:v.selectedWph.scxtwph,scxtwpmc:v.selectedWph.scxtwpmc,ddqf:v.selected_ddqf};
          if(v.selected_ddqf != "2"){ // 机织或者AB
              this.$router.push({"name":"samplingUpdate",params: jsonPara(para)});
          }else{ // 编织
              this.$router.push({"name":"samplingWeavingUpdate",params: jsonPara(para)});
          }
        },
        samplehis(){ // 取样履历
          // 判断是否是编织 。ddqf = "2" samplingWeavingHis 否则 samplingHis
          var v=this;
          if(!v.selectedWph.wph){
             mui.alert("请先选择物料，再操作","错误提示");
             return;
          }
          // 订单号
          v.selectedContract = v.selectedContractItem.ddh;
          if(!v.selectedContract){
            mui.alert("请先选择物料下的订单，再操作","错误提示");
             return;
          }
          // 订单区分
          v.selected_ddqf = v.selectedContractItem.ddqf;
          var para={ddh:v.selectedContract,wph:v.selectedWph.wph,scxtwph:v.selectedWph.scxtwph,scxtwpmc:v.selectedWph.scxtwpmc,ddqf:v.selected_ddqf};

          if(v.selected_ddqf != "2"){// 机织或者AB
            this.$router.push({"name":"samplingHis",params: jsonPara(para)});
          }else{ // 编织
            this.$router.push({"name":"samplingWeavingHis",params: jsonPara(para)});
          }
        },
        // 订单获取
        getContractList(){
          var v = this;
          var wph = v.selectedWph ? v.selectedWph.wph : "";
          v.nyy.doPost("/Sample/getContractList",{ddqf:"all",wph:wph}, 
            function(result){
              if(result.status){
                 v.contractList=result.data.infoLst;
                 if(v.contractList.length>0){
                   v.selectedContractItem = v.contractList[0];
                 }else{
                  v.selectedContractItem = {};
                 }
              }else {
                  mui.toast(result.message);
                  return;
              }
            }
          );
        },
      // 选中事件
      wphSelected(selectedOption,id) {
        var v = this;//{{item.scxtwph}} {{item.scxtwpmc}}
        v.selectedWph = selectedOption;

        var wph = v.selectedWph ? v.selectedWph.wph : "";
        v.nyy.doPost("/Sample/getContractList",{ddqf:"all",wph:wph}, 
          function(result){
            if(result.status){
               v.contractList=result.data.infoLst;
               if(v.contractList.length>0){
                 v.selectedContractItem = v.contractList[0];
               }else{
                v.selectedContractItem = {};
               }
            }else {
                mui.toast(result.message);
                return;
            }
          }
        );
        }
      },
      created() {
        var v=this;
        v.clothQuery();
      }
    }
</script>
<style src="../../static/css/vue-multiselect.min.css"></style>
<style scoped>
  @import "../../static/css/samplinghistory.css";
  @import "../../static/css/filterorder.css";
  .multiselect__input{
   border:none;
}
.multiselect__single{
  white-space: nowrap;
  overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/sampling.vue